/* tslint:disable */
/* eslint-disable */
/**
 * re-order
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SalesWrapLastSelected
 */
export interface SalesWrapLastSelected {
    /**
     * 
     * @type {string}
     * @memberof SalesWrapLastSelected
     */
    articleId?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesWrapLastSelected
     */
    batch?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesWrapLastSelected
     */
    serial?: string;
}

/**
 * Check if a given object implements the SalesWrapLastSelected interface.
 */
export function instanceOfSalesWrapLastSelected(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SalesWrapLastSelectedFromJSON(json: any): SalesWrapLastSelected {
    return SalesWrapLastSelectedFromJSONTyped(json, false);
}

export function SalesWrapLastSelectedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesWrapLastSelected {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'articleId': !exists(json, 'articleId') ? undefined : json['articleId'],
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'serial': !exists(json, 'serial') ? undefined : json['serial'],
    };
}

export function SalesWrapLastSelectedToJSON(value?: SalesWrapLastSelected | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'articleId': value.articleId,
        'batch': value.batch,
        'serial': value.serial,
    };
}

